import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import T from 'i18n-react';
import it from './i18n/it.json';
import { BrowserRouter as Router } from 'react-router-dom';

// Add the texts for your APP
T.setTexts(it);

ReactDOM.render(
    <Router>
        <App />
    </Router>,
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js